module.exports = __webpack_public_path__ + "static/media/2014.7c7760cf.csv";